const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;
const API_KEY = process.env.REACT_APP_API_ACCESS_KEY;

export const getProcessedData = async () => {
  console.log('Fetching data at:', new Date().toISOString());
  try {
    const response = await fetch(`${SERVER_API_URL}/api/processed-data`, {
      headers: {
        'x-api-key': API_KEY
      }
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    console.log('Fetch completed at:', new Date().toISOString());
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    return {};
  }
};